import { SORT_DIRECTION__DESC } from 'react-redux-app/lib/modules/table/constants';
import { defaultFilter as defaultFilterBase } from '../../queryFilter/constants';

import { SITE_ARTICLES_GRID_NAME } from '../constants';

import { getGridFilterByName } from '../../queryFilter/utils/gridFilter';


export const getDefaultFilter = () => ({
  ...defaultFilterBase,
  sortField: 'date',
  sortDirection: SORT_DIRECTION__DESC,
});

export const getGridFilter = location => (
  getGridFilterByName(location, SITE_ARTICLES_GRID_NAME, getDefaultFilter())
);
